
import {defineComponent} from 'vue'
import Xapi from "../../utils/xapi";

export default defineComponent({
  name: "HelpButton",
  props: {
    text: {
      type: String,
      default: '',
    }
  },
  methods: {
    onClick() {
      Xapi.xShowModal({text: this.text})
    }
  },
})
